$(window).on('load', () => {

  /**
  /* Dropdowns
  **/

  $('.toggle-dropdown').click(function(event) {
    event.stopPropagation();

    $('#header-nav a').closest('.dropdown').removeClass('show').hide();
    $('#header-nav a').closest('.dropdown').show();
    setTimeout(function() {
      $('#header-nav .menu .dropdown:visible').addClass('show');
    }, 50);

  });

  $('body').click(function() {
    $('#header-nav .menu .dropdown').removeClass('show').hide();
  });

  /**
  /* Mobile
  **/

  $('#header-top-mobile .head .content.content-1 .burger').click(function(){
    if ($('#header-top-mobile .head .content.content-1 .burger').hasClass('open-menu')) {
      $('#header-top-mobile > .wrapper-content').removeClass('open');
      $('#header-top-mobile .head').removeClass('open-menu');
      $('#header-top-mobile .head .content.content-1 .burger').removeClass('open-menu');
    } else {
      $('#header-top-mobile > .wrapper-content').addClass('open');
      $('#header-top-mobile .head').addClass('open-menu');
      $('#header-top-mobile .head .content.content-1 .burger').addClass('open-menu');
    }
  })

  $('#header-top-mobile > .wrapper-content .content.content-1 .index .el').click(function(){
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
    } else {
      $(this).addClass('open');
    }
  })

  $('#header-top-mobile > .wrapper-content .content.content-1 .index .el .dropdown .sub-el').click(function(){
    $('#header-top-mobile .head .content.content-1').addClass('hide-top');
    $('#header-top-mobile > .wrapper-content .content.content-1').addClass('hide');
    $('#header-top-mobile > .wrapper-content .content.content-'+$(this).data('index')).addClass('show');
  })

})
